import { Provider } from "components/specialize/SpecializeContext";
import { SpecializeList } from "components/specialize/SpecialzeList";
import React from "react";

export const Specializes = () => {
    return (
        <Provider>
            <SpecializeList />
        </Provider>
    );
};
